module.exports = __webpack_public_path__ + "static/media/Large-01MA030K20DTS_CMJN.87f9e22d.png";